module.exports = __webpack_public_path__ + "static/image26@2x-fab4ed3e8905181a3ddfbb2e8510edd5.png";